import { BrandId } from 'utils/override';
import {
  EnumCustomerReviewsBlockBgColorVariant,
  EnumCustomerReviewsBlockReviewSource,
} from '$/(cms)/_modules/cmsService/types';

export const BRAND_DISPLAY_NAMES: Record<BrandId, string> = {
  singsaver: 'SingSaver',
  moneyhero: 'MoneyHero',
  money101: 'Money101',
  moneymax: 'Moneymax',
};

export const BG_COLOR_CLASS_MAP: Record<
  EnumCustomerReviewsBlockBgColorVariant,
  string
> = {
  [EnumCustomerReviewsBlockBgColorVariant.PrimaryLight]:
    'bg-fill/primary-light',
  [EnumCustomerReviewsBlockBgColorVariant.SecondaryLight]:
    'bg-fill/secondary-light',
  [EnumCustomerReviewsBlockBgColorVariant.Alternative_1]:
    'bg-fill/alternative-1',
  [EnumCustomerReviewsBlockBgColorVariant.Alternative_2]:
    'bg-fill/alternative-2',
  [EnumCustomerReviewsBlockBgColorVariant.Alternative_3]:
    'bg-fill/alternative-3',
};

export const REVIEW_SOURCE_LABEL: Record<
  EnumCustomerReviewsBlockReviewSource,
  string
> = {
  [EnumCustomerReviewsBlockReviewSource.GoogleReviews]: 'Google',
};
